import CreateSeedAudiencesLookalikeSize from './CreateSeedAudiencesLookalikeSize.Container';

export default CreateSeedAudiencesLookalikeSize;
